export default class ValueCorners {
    public value: number;
}